var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEFA00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FEFA00",
    strokeOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5048_825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9186 26.8259L27.0255 15.5714C26.9698 14.8463 26.3566 14.2783 25.6294 14.2783H23.8652V14.199C23.8652 12.0673 22.131 10.333 19.9993 10.333C17.8675 10.333 16.1333 12.0673 16.1333 14.199V14.2783H14.3691C13.6419 14.2783 13.0287 14.8462 12.9732 15.5698L12.0798 26.8274C12.0106 27.7288 12.3233 28.6262 12.9376 29.2894C13.5519 29.9526 14.4227 30.333 15.3268 30.333H24.6717C25.5757 30.333 26.4466 29.9526 27.0609 29.2894C27.6752 28.6261 27.9878 27.7288 27.9186 26.8259ZM17.3048 14.199C17.3048 12.7132 18.5136 11.5045 19.9993 11.5045C21.485 11.5045 22.6937 12.7133 22.6937 14.199V14.2783H17.3048V14.199ZM26.2014 28.4934C25.8023 28.9242 25.2591 29.1615 24.6717 29.1615H15.3268C14.7394 29.1615 14.1962 28.9242 13.7971 28.4934C13.398 28.0625 13.2029 27.5026 13.2478 26.9186L14.1411 15.6609C14.1502 15.5425 14.2503 15.4498 14.3691 15.4498H16.1333V16.8925C16.1333 17.216 16.3955 17.4783 16.719 17.4783C17.0425 17.4783 17.3048 17.216 17.3048 16.8925V15.4498H22.6937V16.8925C22.6937 17.216 22.956 17.4783 23.2795 17.4783C23.603 17.4783 23.8652 17.216 23.8652 16.8925V15.4498H25.6294C25.7482 15.4498 25.8483 15.5425 25.8575 15.6625L26.7507 26.917C26.7956 27.5026 26.6005 28.0624 26.2014 28.4934Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6408 20.2663C22.4121 20.0375 22.0412 20.0375 21.8125 20.2663L19.197 22.8818L18.1913 21.8761C17.9626 21.6473 17.5917 21.6473 17.363 21.8761C17.1342 22.1048 17.1342 22.4757 17.363 22.7044L18.7829 24.1243C18.8972 24.2387 19.0471 24.2959 19.197 24.2959C19.3468 24.2959 19.4968 24.2387 19.6111 24.1243L22.6407 21.0947C22.8695 20.8659 22.8695 20.495 22.6408 20.2663Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5048_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrderIcon);
export default __webpack_public_path__ + "static/media/new_order_icon.db35622c14adb9029aab8bb6ba309296.svg";
export { ForwardRef as ReactComponent };